module.exports = __webpack_public_path__ + "img/7.7154ae21.png";